let navigate, location;

export const setNavigation = (nav, loc) => {
  navigate = nav;
  location = loc;
};

export const getNavigate = () => {
  if (!navigate) throw new Error("Navigate no inicializado");
  return navigate;
};

export const getLocation = () => {
  if (!location) throw new Error("Location no inicializado");
  return location;
};